import { render, staticRenderFns } from "./cancelSale.vue?vue&type=template&id=831e4d5e&scoped=true"
import script from "./cancelSale.vue?vue&type=script&lang=js"
export * from "./cancelSale.vue?vue&type=script&lang=js"
import style0 from "./cancelSale.vue?vue&type=style&index=0&id=831e4d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831e4d5e",
  null
  
)

export default component.exports